import * as fromDatatype from '../datatype-library/index';

export interface app_sequence_counter_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  doc_type: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  module_name: fromDatatype.VarcharDatatypeInterface;
  composite_guid_01: fromDatatype.GuidDataFieldInterface;
  composite_guid_02: fromDatatype.GuidDataFieldInterface;
  composite_guid_03: fromDatatype.GuidDataFieldInterface;
  composite_guid_04: fromDatatype.GuidDataFieldInterface;
  composite_guid_05: fromDatatype.GuidDataFieldInterface;
  composite_guid_06: fromDatatype.GuidDataFieldInterface;
  composite_guid_07: fromDatatype.GuidDataFieldInterface;
  composite_guid_08: fromDatatype.GuidDataFieldInterface;
  composite_guid_09: fromDatatype.GuidDataFieldInterface;
  composite_guid_10: fromDatatype.GuidDataFieldInterface;
  sequence_num: fromDatatype.BigIntegerDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_sequence_counter_RowClass
  implements app_sequence_counter_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  doc_type: fromDatatype.VarcharDatatypeInterface;
  logic: fromDatatype.VarcharDatatypeInterface;
  module_name: fromDatatype.VarcharDatatypeInterface;
  composite_guid_01: fromDatatype.GuidDataFieldInterface;
  composite_guid_02: fromDatatype.GuidDataFieldInterface;
  composite_guid_03: fromDatatype.GuidDataFieldInterface;
  composite_guid_04: fromDatatype.GuidDataFieldInterface;
  composite_guid_05: fromDatatype.GuidDataFieldInterface;
  composite_guid_06: fromDatatype.GuidDataFieldInterface;
  composite_guid_07: fromDatatype.GuidDataFieldInterface;
  composite_guid_08: fromDatatype.GuidDataFieldInterface;
  composite_guid_09: fromDatatype.GuidDataFieldInterface;
  composite_guid_10: fromDatatype.GuidDataFieldInterface;
  sequence_num: fromDatatype.BigIntegerDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
